import { DashboardUtils } from 'src/app/modules/shared/DashboardUtils';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/modules/shared/services/sites.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-dashboard-site-concessionaria-page',
    templateUrl: './dashboard-site-concessionaria-page.component.html',
    styleUrls: ['./dashboard-site-concessionaria-page.component.css']
})
export class DashboardSiteConcessionariaPageComponent implements OnInit, OnDestroy {

    public site: any;
    public realTimeCards: any[];
    public charts: any[];
    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;

    public concessionaria: any;
    public idConcessionaria;
    constructor(private route: ActivatedRoute, public authenticationService: AuthenticationService, private sitesService: SitesService, private dataService: DataService,
        private spinner: NgxSpinnerService) {
        this.realTimeCards = [];
        this.charts = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.idConcessionaria = params['idConcessionaria'];
            this.spinner.show();
            this.sitesService.get(params['id']).subscribe(response => {
                this.site = response;
                this.concessionaria = this.site.concessionarias.filter((x: any) => (x.id == this.idConcessionaria))[0];
                
                // 1. Card de Potência Ativa
                if(this.concessionaria.tagPotenciaAtiva && this.concessionaria.tagPotenciaAtiva.tagRealTimeValue) {
                    let cardPotenciaAtiva = { tags: [], getIconClass: () => "image-demanda", getLabel: () =>  "Potência Ativa", getValue: () => {}};                
                    cardPotenciaAtiva.tags.push({ tag: this.concessionaria.tagPotenciaAtiva.tagRealTimeValue });                    
                    cardPotenciaAtiva.getValue = () => cardPotenciaAtiva.tags.length == 0 ? 'N/A' : !isNaN(cardPotenciaAtiva.tags[0].value) ? (cardPotenciaAtiva.tags[0].value.toFixed(1)==-0?"0,0kW":cardPotenciaAtiva.tags[0].value.toFixed(1).replace(/[.]/, ",") +"kW") : "-";
                    this.realTimeCards.push(cardPotenciaAtiva);
                }                
                
                // 2. Card de Tensão
                if(this.concessionaria.tagTensao && this.concessionaria.tagTensao.tagRealTimeValue) {
                    let cardTensao = { tags: [],  getIconClass: () => "image-tensao", getLabel: () =>  "Tensão", getValue: () => {}};
                    cardTensao.tags.push({ tag: this.concessionaria.tagTensao.tagRealTimeValue });    
                    cardTensao.getValue = () => cardTensao.tags.length == 0 ? 'N/A' : !isNaN(cardTensao.tags[0].value) ? (cardTensao.tags[0].value.toFixed(1)==-0?"0,0V":cardTensao.tags[0].value.toFixed(1).replace(/[.]/, ",") +"V" ): "-";
                    this.realTimeCards.push(cardTensao);
                } 

                // 3. Card de Status do Disjuntor
                if(this.concessionaria.tagStatusDisjuntor && this.concessionaria.tagStatusDisjuntor.tagRealTimeValue) {
                    let iconsByStatus = {};
                    iconsByStatus['0'] = "image-concessionaria-off";
                    iconsByStatus['1'] = "image-concessionaria-on";                    
                    let cardConcessionaria = { tags: [], getIconClass: () => iconsByStatus[cardConcessionaria.tags[0].value] ? iconsByStatus[cardConcessionaria.tags[0].value] : "image-concessionaria-off", getLabel: () =>  "Status do Disjuntor", getValue: () => {}}; 
                    cardConcessionaria.tags.push({ tag: this.concessionaria.tagStatusDisjuntor.tagRealTimeValue });            
                    cardConcessionaria.getValue = () => "";
                    this.realTimeCards.push(cardConcessionaria);
                }                
                
                // 1. Gráfico de Potência Ativa
                if(this.concessionaria.tagPotenciaAtiva && this.concessionaria.tagPotenciaAtiva.tagHistoricalValues) {
                    let chartPotenciaAtiva = DashboardUtils.buildDefaultChart("Potência Ativa (kW)", this.concessionaria.tagPotenciaAtiva);
                    this.updateChart(chartPotenciaAtiva);
                    this.charts.push(chartPotenciaAtiva);
                }
                
                // 2. Gráfico de Tensão
                if(this.concessionaria.tagTensao && this.concessionaria.tagTensao.tagHistoricalValues) {
                    let chartTensao = DashboardUtils.buildDefaultChart("Tensão (V)", this.concessionaria.tagTensao);
                    this.updateChart(chartTensao);
                    this.charts.push(chartTensao);
                }
                
                this.refreshCardDataSubscription = timer(0, environment.dashboard.cardUpdatePeriodSeconds * 1000).subscribe(result => { 
                    this.refreshCardData();
                });
                this.refreshChartDataSubscription = timer(0, environment.dashboard.chartUpdatePeriodSeconds * 1000).subscribe(result => { 
                    this.refreshChartData();
                });
                this.spinner.hide();
            });
        });
    };

    ngOnDestroy() {
        if(this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if(this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    };

    refreshCardData() {
        var tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({items: tags}).subscribe(response => {
            for(let i in response.data) {
                Object.assign(tags[i], response.data[i]);                
            }
        });
    };

    refreshChartData() {
        this.charts.forEach(chart => {            
            this.updateChart(chart);    
        });
    };

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    };
}
